/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { CmTeasableCommon_CmArticleImpl_Fragment, CmTeasableCommon_CmAudioImpl_Fragment, CmTeasableCommon_CmChannelImpl_Fragment, CmTeasableCommon_CmCollectionImpl_Fragment, CmTeasableCommon_CmDownloadImpl_Fragment, CmTeasableCommon_CmDynamicListImpl_Fragment, CmTeasableCommon_CmExternalLinkImpl_Fragment, CmTeasableCommon_CmGalleryImpl_Fragment, CmTeasableCommon_CmhtmlImpl_Fragment, CmTeasableCommon_CmImageMapImpl_Fragment, CmTeasableCommon_CmInteractiveImpl_Fragment, CmTeasableCommon_CmLocTaxonomyImpl_Fragment, CmTeasableCommon_CmMediaImpl_Fragment, CmTeasableCommon_CmNavigationImpl_Fragment, CmTeasableCommon_CmPersonImpl_Fragment, CmTeasableCommon_CmPictureImpl_Fragment, CmTeasableCommon_CmPlaceholderImpl_Fragment, CmTeasableCommon_CmProductImpl_Fragment, CmTeasableCommon_CmQueryListImpl_Fragment, CmTeasableCommon_CmSelectionRulesImpl_Fragment, CmTeasableCommon_CmSpinnerImpl_Fragment, CmTeasableCommon_CmTaxonomyImpl_Fragment, CmTeasableCommon_CmTeasableImpl_Fragment, CmTeasableCommon_CmTeaserImpl_Fragment, CmTeasableCommon_CmVideoImpl_Fragment, CmTeasableCommon_CmVisualImpl_Fragment, CmTeasableCommon_FormEditorImpl_Fragment, CmTeasableCommon_SosAmountIncreaseFormImpl_Fragment, CmTeasableCommon_SosAuthorImpl_Fragment, CmTeasableCommon_SosChartImpl_Fragment, CmTeasableCommon_SosContactImpl_Fragment, CmTeasableCommon_SosDonationCardImpl_Fragment, CmTeasableCommon_SosDonationCertificateImpl_Fragment, CmTeasableCommon_SosDonationFormImpl_Fragment, CmTeasableCommon_SosDonationProductImpl_Fragment, CmTeasableCommon_SosDonationProgressImpl_Fragment, CmTeasableCommon_SosDonationToolImpl_Fragment, CmTeasableCommon_SosEventImpl_Fragment, CmTeasableCommon_SosFilterTeaserImpl_Fragment, CmTeasableCommon_SosInternalLinkImpl_Fragment, CmTeasableCommon_SosJobTeaserImpl_Fragment, CmTeasableCommon_SosLocationImpl_Fragment, CmTeasableCommon_SosNewsImpl_Fragment, CmTeasableCommon_SosNotificationImpl_Fragment, CmTeasableCommon_SosOfferImpl_Fragment, CmTeasableCommon_SosOrderFormImpl_Fragment, CmTeasableCommon_SosOrganisationImpl_Fragment, CmTeasableCommon_SosOverlayImpl_Fragment, CmTeasableCommon_SosPressreleaseImpl_Fragment, CmTeasableCommon_SosPublicationImpl_Fragment, CmTeasableCommon_SosRedirectPageImpl_Fragment, CmTeasableCommon_SosSpecialTopicCategoryImpl_Fragment, CmTeasableCommon_SosSpecialTopicImpl_Fragment, CmTeasableCommon_SosTeaserImpl_Fragment, CmTeasableCommon_SosTextfragmentImpl_Fragment, CmTeasableCommon_SosTooltipImpl_Fragment, CmTeasableCommon_SosWimmelbildImpl_Fragment, CmTeasableCommon_ViewTypeHeroCollection_Fragment } from './CMTeasableCommon.fragment';
import { CmTeasable_CmArticleImpl_Fragment, CmTeasable_CmAudioImpl_Fragment, CmTeasable_CmChannelImpl_Fragment, CmTeasable_CmCollectionImpl_Fragment, CmTeasable_CmDownloadImpl_Fragment, CmTeasable_CmDynamicListImpl_Fragment, CmTeasable_CmExternalLinkImpl_Fragment, CmTeasable_CmGalleryImpl_Fragment, CmTeasable_CmhtmlImpl_Fragment, CmTeasable_CmImageMapImpl_Fragment, CmTeasable_CmInteractiveImpl_Fragment, CmTeasable_CmLocTaxonomyImpl_Fragment, CmTeasable_CmMediaImpl_Fragment, CmTeasable_CmNavigationImpl_Fragment, CmTeasable_CmPersonImpl_Fragment, CmTeasable_CmPictureImpl_Fragment, CmTeasable_CmPlaceholderImpl_Fragment, CmTeasable_CmProductImpl_Fragment, CmTeasable_CmQueryListImpl_Fragment, CmTeasable_CmSelectionRulesImpl_Fragment, CmTeasable_CmSpinnerImpl_Fragment, CmTeasable_CmTaxonomyImpl_Fragment, CmTeasable_CmTeasableImpl_Fragment, CmTeasable_CmTeaserImpl_Fragment, CmTeasable_CmVideoImpl_Fragment, CmTeasable_CmVisualImpl_Fragment, CmTeasable_FormEditorImpl_Fragment, CmTeasable_SosAmountIncreaseFormImpl_Fragment, CmTeasable_SosAuthorImpl_Fragment, CmTeasable_SosChartImpl_Fragment, CmTeasable_SosContactImpl_Fragment, CmTeasable_SosDonationCardImpl_Fragment, CmTeasable_SosDonationCertificateImpl_Fragment, CmTeasable_SosDonationFormImpl_Fragment, CmTeasable_SosDonationProductImpl_Fragment, CmTeasable_SosDonationProgressImpl_Fragment, CmTeasable_SosDonationToolImpl_Fragment, CmTeasable_SosEventImpl_Fragment, CmTeasable_SosFilterTeaserImpl_Fragment, CmTeasable_SosInternalLinkImpl_Fragment, CmTeasable_SosJobTeaserImpl_Fragment, CmTeasable_SosLocationImpl_Fragment, CmTeasable_SosNewsImpl_Fragment, CmTeasable_SosNotificationImpl_Fragment, CmTeasable_SosOfferImpl_Fragment, CmTeasable_SosOrderFormImpl_Fragment, CmTeasable_SosOrganisationImpl_Fragment, CmTeasable_SosOverlayImpl_Fragment, CmTeasable_SosPressreleaseImpl_Fragment, CmTeasable_SosPublicationImpl_Fragment, CmTeasable_SosRedirectPageImpl_Fragment, CmTeasable_SosSpecialTopicCategoryImpl_Fragment, CmTeasable_SosSpecialTopicImpl_Fragment, CmTeasable_SosTeaserImpl_Fragment, CmTeasable_SosTextfragmentImpl_Fragment, CmTeasable_SosTooltipImpl_Fragment, CmTeasable_SosWimmelbildImpl_Fragment, CmTeasable_ViewTypeHeroCollection_Fragment } from './CMTeasable.fragment';
import { CmDownloadFragment } from './CMDownload.fragment';
import { CmExternalLinkFragment } from './CMExternalLink.fragment';
import { CmChannel_CmChannelImpl_Fragment, CmChannel_SosDonationProductImpl_Fragment, CmChannel_SosOfferImpl_Fragment, CmChannel_SosOrganisationImpl_Fragment, CmChannel_SosRedirectPageImpl_Fragment, CmChannel_SosSpecialTopicCategoryImpl_Fragment, CmChannel_SosSpecialTopicImpl_Fragment, CmChannel_SosWimmelbildImpl_Fragment } from './CMChannel.fragment';
import { CmhtmlFragment } from './CMHtml.fragment';
import { SosTextfragmentFragment } from './SOSTextfragment.fragment';
import { SosTeaserFragment } from './SOSTeaser.fragment';
import { SosDonationCardFragment } from './SOSDonationCard.fragment';
import { gql } from '@apollo/client';
import { CmTeasableCommonFragmentDoc } from './CMTeasableCommon.fragment';
import { CmTeasableFragmentDoc } from './CMTeasable.fragment';
import { CmDownloadFragmentDoc } from './CMDownload.fragment';
import { CmExternalLinkFragmentDoc } from './CMExternalLink.fragment';
import { CmChannelFragmentDoc } from './CMChannel.fragment';
import { CmhtmlFragmentDoc } from './CMHtml.fragment';
import { SosTextfragmentFragmentDoc } from './SOSTextfragment.fragment';
import { SosTeaserFragmentDoc } from './SOSTeaser.fragment';
import { SosDonationCardFragmentDoc } from './SOSDonationCard.fragment';
export type CmCollection2_CmCollectionImpl_Fragment = (
  { __typename?: 'CMCollectionImpl', viewtype?: string | null, name: string, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
    & CmChannel_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
    & CmChannel_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
    & CmChannel_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
    & CmChannel_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
    & CmChannel_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
    & CmChannel_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
    & CmChannel_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
    & CmChannel_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_CmCollectionImpl_Fragment
);

export type CmCollection2_CmDynamicListImpl_Fragment = (
  { __typename?: 'CMDynamicListImpl', viewtype?: string | null, name: string, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
    & CmChannel_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
    & CmChannel_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
    & CmChannel_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
    & CmChannel_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
    & CmChannel_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
    & CmChannel_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
    & CmChannel_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
    & CmChannel_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_CmDynamicListImpl_Fragment
);

export type CmCollection2_CmGalleryImpl_Fragment = (
  { __typename?: 'CMGalleryImpl', viewtype?: string | null, name: string, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
    & CmChannel_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
    & CmChannel_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
    & CmChannel_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
    & CmChannel_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
    & CmChannel_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
    & CmChannel_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
    & CmChannel_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
    & CmChannel_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_CmGalleryImpl_Fragment
);

export type CmCollection2_CmQueryListImpl_Fragment = (
  { __typename?: 'CMQueryListImpl', viewtype?: string | null, name: string, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
    & CmChannel_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
    & CmChannel_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
    & CmChannel_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
    & CmChannel_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
    & CmChannel_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
    & CmChannel_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
    & CmChannel_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
    & CmChannel_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_CmQueryListImpl_Fragment
);

export type CmCollection2_CmSelectionRulesImpl_Fragment = (
  { __typename?: 'CMSelectionRulesImpl', viewtype?: string | null, name: string, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
    & CmChannel_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
    & CmChannel_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
    & CmChannel_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
    & CmChannel_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
    & CmChannel_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
    & CmChannel_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
    & CmChannel_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
    & CmChannel_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_CmSelectionRulesImpl_Fragment
);

export type CmCollection2_ViewTypeHeroCollection_Fragment = (
  { __typename?: 'ViewTypeHeroCollection', viewtype?: string | null, name: string, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
    & CmChannel_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
    & CmChannel_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
    & CmChannel_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
    & CmChannel_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
    & CmChannel_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
    & CmChannel_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
    & CmChannel_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
    & CmChannel_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasableCommon_ViewTypeHeroCollection_Fragment
);

export type CmCollection2Fragment = CmCollection2_CmCollectionImpl_Fragment | CmCollection2_CmDynamicListImpl_Fragment | CmCollection2_CmGalleryImpl_Fragment | CmCollection2_CmQueryListImpl_Fragment | CmCollection2_CmSelectionRulesImpl_Fragment | CmCollection2_ViewTypeHeroCollection_Fragment;

export const CmCollection2FragmentDoc = gql`
    fragment CMCollection2 on CMCollection {
  ...CMTeasableCommon
  viewtype
  name
  items {
    ...CMTeasable
    ...CMExternalLink
    ...CMDownload
    ...CMChannel
    ...CMHTML
    ...SOSTextfragment
    ...SOSTeaser
    ...SOSDonationCard
  }
  teasableItems {
    ...CMTeasable
  }
}
    ${CmTeasableCommonFragmentDoc}
${CmTeasableFragmentDoc}
${CmExternalLinkFragmentDoc}
${CmDownloadFragmentDoc}
${CmChannelFragmentDoc}
${CmhtmlFragmentDoc}
${SosTextfragmentFragmentDoc}
${SosTeaserFragmentDoc}
${SosDonationCardFragmentDoc}`;